<script>
  import Checkbox from 'smelte/src/components/Checkbox'
  export let items = [{value: 'a', label: 'a'}]
  export let group = []
  export let add = ''
</script>

{#each items as u, i}
  <div class={add}>
    <Checkbox color="red" bind:value={u.value} label={u.label} bind:group={group} />
  </div>
{/each}
